import React from "react";
import { Typography, Divider } from "antd";
import {
  FaUser,
  FaCalendarAlt,
  FaPhone,
  FaHospital,
  FaIdCard,
  FaShieldAlt,
  FaNotesMedical,
} from "react-icons/fa";
import styles from "./PatientInfo.module.css";

const { Text } = Typography;

// Utility function to format date string
const formatDate = (dateString) => {
  if (!dateString) return "Chưa có thông tin";
  return dateString.split(' ')[0]; // Lấy phần trước dấu cách
};

// Utility function to handle null values
const formatValue = (value, fallback = "Chưa có thông tin") => {
  return value || fallback;
};

const PatientInfo = ({
  data,
}) => {
  const {
    maKcb,
    hoTen,
    ngayDk,
    maCoSoKcb,
    ngayRv,
    isBHYT,
    ngaySinh,
    soCccd,
    soDienThoai,
    chanDoan,
    benhVien
  } = data;

  return (
    <div className={styles.patientContainer}>
      {/* Header with Avatar and Basic Info */}
      <div className={styles.headerSection}>
        <div className={styles.patientAvatar}>
          <FaUser />
        </div>
        <div className={styles.patientInfo}>
          <div className={styles.patientHeaderRow}>
            <div className={styles.patientNameContainer}>
              <div className={styles.patientName}>
                {formatValue(hoTen)}
              </div>
              <div className={styles.wrapBirthDay}>
                <FaCalendarAlt className={styles.infoIcon} />
                <Text className={styles.infoValue}>{formatValue(ngaySinh)}</Text>
              </div>
            </div>
            <div className={styles.patientMeta}>
              <Text className={styles.metaItem}>
                <span className={styles.metaLabel}>Mã KCB:</span>
                <span className={styles.metaValue}>{formatValue(maKcb)}</span>
              </Text>
              {isBHYT && (
                <div className={styles.bhytBadge}>
                  <FaShieldAlt />
                  <div>BHYT</div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <Divider className={styles.sectionDivider} />

      {/* Information Grid */}
      <div className={styles.infoGrid}>
        <div className={styles.infoColumn}>
          <div className={styles.infoItems}>
            <div className={styles.infoItem}>
              <FaPhone className={styles.infoIcon} />
              <div className={styles.infoContent}>
                <Text className={styles.infoLabel}>Số điện thoại</Text>
                <Text className={styles.infoValue}>{formatValue(soDienThoai)}</Text>
              </div>
            </div>
            <div className={styles.infoItem}>
              <FaCalendarAlt className={styles.infoIcon} />
              <div className={styles.infoContent}>
                <Text className={styles.infoLabel}>Ngày đăng ký</Text>
                <Text className={styles.infoValue}>{formatDate(ngayDk)}</Text>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.infoColumn}>
          <div className={styles.infoItems}>
            <div className={styles.infoItem}>
              <FaIdCard className={styles.infoIcon} />
              <div className={styles.infoContent}>
                <Text className={styles.infoLabel}>CCCD</Text>
                <Text className={styles.infoValue}>{formatValue(soCccd)}</Text>
              </div>
            </div>
            <div className={styles.infoItem}>
              <FaCalendarAlt className={styles.infoIcon} />
              <div className={styles.infoContent}>
                <Text className={styles.infoLabel}>Ngày ra viện</Text>
                <Text className={styles.infoValue}>{formatDate(ngayRv)}</Text>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.infoColumn}>
        <div className={styles.infoItem}>
          <FaHospital className={styles.infoIcon} />
          <div className={styles.infoContent}>
            <Text className={styles.infoLabel}>Khám tại</Text>
            <Text className={styles.infoValue}>{formatValue(benhVien)}</Text>
          </div>
        </div>
        {chanDoan && (
          <div className={styles.infoItem}>
            <FaNotesMedical className={styles.infoIcon} />
            <div className={styles.infoContent}>
              <Text className={styles.infoLabel}>Chẩn đoán</Text>
              <Text className={styles.infoValue}>{formatValue(chanDoan)}</Text>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default PatientInfo;
